import { createElementIdSlice } from '../utils/action/createElementSlice';
export const ContainerState = createElementIdSlice({
    elementName: 'container',
    initialState: {},
    reducers: {},
});
